import { RouteObject } from "react-router-dom";
import { peopleRoutes } from "./people/peopleRoutes";
import { ministriesRoutes } from "./ministries/ministriesRoutes";
import { IconChecklist, IconHexagons, IconShieldCheck, IconUsers } from "@tabler/icons-react";
import { childProtectionRoutes } from "./child-protection/childProtectionRoutes";
import { settingsRoutes } from "./settings/settingsRoutes";
import { RouteErrorScreen } from "./core/components/RouteErrorScreen";
import { songLibrariesRoutes } from "./song-libraries/songLibrariesRoutes";
import { routeCan } from "./authentication/routeCan";
import { Action } from "./casl/Action";

/** Offered to anybody with a duty to come (SELF04), so it lets in somebody holding no role (#287) */
export const myRotaRoute: RouteObject = {
    path: "my-rota",
    handle: { crumb: "My Rota", icon: IconChecklist },
    errorElement: <RouteErrorScreen title="This screen's not working right" />,
    lazy: () => import("./my-duties/MyDutiesScreen"),
    children: [
        { index: true, lazy: () => import("./my-duties/tabs/MyDutiesTab") },
        { path: "whats-on", lazy: () => import("./my-duties/tabs/MyWhatsOnTab") },
        { path: "away-dates", lazy: () => import("./my-duties/tabs/MyAwayDatesTab") },
        { path: "phone-calendar", lazy: () => import("./my-duties/tabs/MyPhoneCalendarTab") },
    ],
};

export const protectedRoutes: RouteObject[] = [
    // Application modules
    { path: "people", children: peopleRoutes, handle: { crumb: "People", icon: IconUsers } },
    { path: "ministries", children: ministriesRoutes, handle: { crumb: "Ministries", icon: IconHexagons } },

    {
        path: "song-libraries",
        handle: { crumb: "Song Libraries", icon: IconChecklist },
        children: songLibrariesRoutes,
    },

    {
        path: "child-protection",
        children: childProtectionRoutes,
        handle: { crumb: "Child Protection", icon: IconShieldCheck },
    },

    {
        path: "settings",
        children: settingsRoutes,
    },

    // Onboarding, for a church's admins setting up a new hub (ONB01, ONB13)
    {
        path: "welcome",
        handle: routeCan(Action.Manage, "all"),
        lazy: () => import("./onboarding/OnboardingWelcomeScreen"),
    },
    {
        path: "onboarding/:onboardingPart",
        handle: routeCan(Action.Manage, "all"),
        lazy: () => import("./onboarding/OnboardingPartScreen"),
    },
];
